import React from "react";
import SignupForm from "../components/signupForm";
import { PaymentMethod } from "@stripe/stripe-js";
import { SignupFormData } from "../components/signupForm/types";
import { createCustomer } from "../api/createCustomer";
import { createSubscription } from "../api/createSubscription";
import { retrySubscription } from "../api/retrySubscription";

const SignupRoute: React.FC = () => {
  return <SignupForm handlePaymentSubmit={handlePaymentSubmit} />;
};

export default SignupRoute;

async function handlePaymentSubmit(
  method: PaymentMethod,
  invoiceId: string | undefined,
  customerId: string | undefined,
  priceLookUpKey: string,
  memberDetails: SignupFormData
) {
  if(invoiceId && customerId) {
    return await retrySubscription({
      customerId,
      invoiceId,
      paymentMethodId: method.id,
      priceLookUpKey,
    });
  }
  else {
    const customer = await createCustomer(memberDetails);
    return await createSubscription({
      customerId: customer.id,
      paymentMethodId: method.id,
      priceLookUpKey,
    });
  }
}
